<template>
  <div>
    <div class="control">
      <div class="control__title">
        <div class="title">
          <div class="title-text">
            {{ title }}
          </div>
          <div class="control__helper">
            <div
              class="control__trigger"
              @mouseover="showHint = true"
              @mouseleave="showHint = false"
            >
              <img
                src="https://sirv.sirv.com/website/theme2/icon/question.svg"
                :alt="hint"
              >
            </div>
            <div
              v-show="showHint"
              class="hint"
            >
              {{ hint }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="(action, key) in maxSelects"
        :key="action"
      >
        <OrderItemInput
          v-if="showAction(key)"
          :select="values[key]"
          :status="selectStatuses.length > 0 ? selectStatuses[key] : false"
          :index="key + 1"
          :options="options"
          @changeOption="changeOption"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import OrderItemInput from '@/widgets/options/OrderItemInput'
export default {
  name: 'OrderInput',
  components: {
    OrderItemInput
  },
  props: {
    default: {
      type: [String, Array],
      default: '',
    },
    title: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean
    },
    options: {
      type: Array,
      default: Function
    },
    parameter: {
      type: String,
      default: ''
    },
    eventClick: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      maxSelects: 10,
      values: [],
      selectStatuses: [],
      showHint: false
    }
  },
  computed: {
    ...mapState(['clearOptions', 'settings']),
  },
  watch: {
    clearOptions(value) {

      if (value) {
        this.initializeFromDefault(this.default);
      }
    }
  },
  mounted() {
    this.initializeFromDefault(this.default);
  },
  emits: ['changeOption'],
  methods: {
    initializeFromDefault(defaultValueString) {
      let parsedValues = [];
      if (defaultValueString && typeof defaultValueString === 'string' && defaultValueString.startsWith('[') && defaultValueString.endsWith(']')) {
        try {
          parsedValues = JSON.parse(defaultValueString.replace(/'/g, '"'));
          if (!Array.isArray(parsedValues)) {
              console.warn('OrderInput default value parsed but is not an array:', parsedValues);
              parsedValues = [];
          }
        } catch (e) {
          console.error('Failed to parse OrderInput default value:', defaultValueString, e);
          parsedValues = [];
        }
      } else if (Array.isArray(defaultValueString)) {
          parsedValues = defaultValueString;
      } else {
          parsedValues = [];
      }

      this.values = [...parsedValues];
      this.selectStatuses = Array(parsedValues.length).fill(true);

      const selectedValue = this.values;
      const formattedValue = selectedValue.length > 0 ?
        JSON.stringify(selectedValue).replace(/"/g, '\'') : '';

      this.$emit('changeOption', {
        parameter: `${this.parameter}`,
        separator: ':',
        value: formattedValue,
        isInitial: true
      });
    },
    showAction(index) {
      return index === 0 || !!this.values[index - 1] ? true : false
    },
    changeOption (payload) {
      while (this.selectStatuses.length < payload.index) this.selectStatuses.push(false);
      while (this.values.length < payload.index) this.values.push(undefined);

      this.selectStatuses[payload.index - 1] = payload.status
      this.values[payload.index - 1] = payload.status ? payload.value : undefined;

      if (this.selectStatuses[0] === false) {
          this.values = []
          this.selectStatuses = []
      } else {
          const findIndexFalse = this.selectStatuses.findIndex((s, i) => i > 0 && s === false);
          if (findIndexFalse !== -1) {
              this.selectStatuses = this.selectStatuses.slice(0, findIndexFalse);
              this.values = this.values.slice(0, findIndexFalse);
          }
      }
      this.values = this.values.filter(v => v !== undefined && v !== null);
      this.selectStatuses = Array(this.values.length).fill(true);

      const selectedValue = this.values;
      const formattedValue = selectedValue.length > 0 ?
        JSON.stringify(
          selectedValue
        ).replace(/"/g, '\'') : ''
      this.$emit('changeOption', {
        parameter: `${this.parameter}`,
        separator: ':',
        value: formattedValue
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mb-15 {
  margin-bottom: 15px;
}
.control__action {
  display: flex;
  align-items: center;
}
</style>
